export interface EquipmentGroup {
    equgrp_id?: number
    equgrp_name?: string
    free_flug?: boolean
    str_id?: number
}

export interface ObjectToEquipmentGroupProps {
    equgrp_id?: number | string
    equgrp_name?: string
    free_flug?: boolean | string
    str_id?: number | string
}

export const ObjectToEquipmentGroup = (obj: ObjectToEquipmentGroupProps): EquipmentGroup => {
    return {
        equgrp_id: typeof obj.equgrp_id == 'string' ? parseInt(obj.equgrp_id) : obj.equgrp_id,
        equgrp_name: obj.equgrp_name,
        free_flug: typeof obj.free_flug == 'string' ? (obj.free_flug == "1" ? true : false) : obj.free_flug,
        str_id: typeof obj.str_id == 'string' ? parseInt(obj.str_id) : obj.str_id,
    }
}